import { Module } from 'vuex'

import { LogState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const progress = {
  today: -1,
  yesterday: -1,
  monthly: -1,
  lastMonth: -1,
}

const state: LogState = {
  isLogsLoading: false,
  logs: [],
  isProgressesLoading: false,
  progresses: {
    checked: { ...progress },
    ng: { ...progress },
    uncheckedSystemNgToLeaderOk: { ...progress },
    uncheckedSystemNgToLeaderNg: { ...progress },
    linkerNgToLeaderOk: { ...progress },
    linkerNgToLeaderNg: { ...progress },
    createdItem: { ...progress },
    matchedApprove: { ...progress },
    matchedReMatch: { ...progress },
    matchedToBeDeleted: { ...progress },
    matchedDelete: { ...progress },
    reMatchedApprove: { ...progress },
    reMatchedReMatch: { ...progress },
    reMatchedToBeDeleted: { ...progress },
    reMatchedDelete: { ...progress },
  },
}

export const log: Module<LogState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
